export const authStates = {
    forgotState: 'forgot_password',
    resetState: 'reset_password',
    loginState: 'login_state',
};